import * as nanoid from 'nanoid';
import { Subscription } from 'rxjs';

export class SubscriptionPool {
    private subscriptions = new Map<string, Subscription>();

    public add(subscription: Subscription, key: string = nanoid(4)) {
        subscription.add(() => {
            this.subscriptions.delete(key);
        });

        this.subscriptions.set(key, subscription);
    }

    public get(key: string) {
        return this.subscriptions.get(key);
    }

    public flush() {
        const keys = this.subscriptions.keys();
        for (const key of keys) {
            const subscription = this.subscriptions.get(key) as Subscription;
            subscription.unsubscribe();
        }
    }
}
